import classes from './NavContainer.module.css';
import { ReactComponent as HomeIcon } from '../../../img/home_icon.svg';
import { FaBoxes, FaUsersCog, FaWarehouse } from 'react-icons/fa';
import { BsShop, BsBoxSeam } from 'react-icons/bs';
import { AiFillAmazonCircle } from 'react-icons/ai';
import { MdOutlineLocalShipping, MdOutlineFindInPage } from 'react-icons/md';

export const getIcon = (name: string | undefined, type?: string) => {
  const style = `${
    type === 'dashboard' ? classes.dashIcon : classes.dashNavIcon
  }`;
  switch (name) {
    case 'bybrand':
      return <BsShop className={style} />;
    case 'byitem':
      return <BsBoxSeam className={style} />;
    case 'users':
      return <FaUsersCog className={style} />;
    case 'home':
      return <HomeIcon className={style} />;
    case 'warehouse':
      return <FaWarehouse className={style} />;
    case 'fbafreight':
      return <AiFillAmazonCircle className={style} />;
    case 'storage':
      return <FaBoxes className={style} />;
    case 'inboundFreight':
      return <MdOutlineLocalShipping className={style} />;
    case 'itemlookup':
      return <MdOutlineFindInPage className={style} />;
    default:
      return null;
  }
};

export const startLinks = (leftData: any[], pathname: string): any[] => {
  const data: any[] = [];
  if (Array.isArray(leftData))
    leftData.forEach((d) => {
      if (d.type === 'list' && Array.isArray(d.list)) {
        d.list.forEach((l: any) => {
          if (l.url) {
            data.push({
              path: l.url,
              isActive: l.url === pathname
            });
          }
        });
      } else if (d.url) {
        data.push({
          path: d.url,
          isActive: d.include
            ? pathname.includes(d.include)
            : d.url === pathname
        });
      }
    });

  return data;
};
